
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[username]",
      function () {
        return require("private-next-pages/[username]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[username]"])
      });
    }
  